import _ from 'lodash';

export default function addAlert(report, key, value = '') {
  _.set(report, `display.alerts.${key}`, value);
}
